import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const STATUSES = [
  { key: "commande_passee", label: "Commande passée" },
  { key: "personnalisation", label: "Personnalisation en cours" },
  { key: "impression", label: "Préparation / impression" },
  { key: "expediee", label: "Commande expédiée" },
  { key: "livraison", label: "En cours de livraison" },
  { key: "livree", label: "Livrée" },
];

export const errMsg = (e) => e?.response?.data?.detail || "Une erreur est survenue";
export const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
